import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('ph_auth_user');
      if (stored) {
        setUser(JSON.parse(stored));
      }
    } catch (_) {}
    setIsLoading(false);
  }, []);

  const login = async ({ email, password }) => {
    if (!email || !password) {
      throw new Error('Email and password are required');
    }
    const mockUser = { id: 'demo-user', email };
    setUser(mockUser);
    localStorage.setItem('ph_auth_user', JSON.stringify(mockUser));
    return mockUser;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('ph_auth_user');
  };

  const value = useMemo(() => ({ user, isLoading, login, logout, isAuthenticated: !!user }), [user, isLoading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const RequireAuth = ({ children, fallback }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (!isAuthenticated) return fallback || null;
  return children;
};


